




























import { Vue, Component } from 'vue-property-decorator';
import to from 'await-to-js';
import moduleStore from '../store/migu';

@Component({})
@moduleStore.initVuex({
  mutationNames: moduleStore.mutationNames,
  actionNames: moduleStore.actionNames,
})
export default class workTemplate extends Vue {

  loading: Boolean = false;
  finished: Boolean = true;
  page: number = 1;
  pageSize: number = 10;
  total_pages: number = 0;
  list = [];
  
  async mounted() {
    await this.getList();
    this.$nextTick(() => {
      this.$emit('anchor');
    })
  }

  async getList() {
    this.loading = true;
    this.finished = false;

    const [err, res] = await to(this.$http('getTemplateList', {
      page: this.page,
      pageSize: this.pageSize,
      resourceType: 'ONE_CLICK'
    }));

    this.loading = false;
    if (err || res.code !== 200 || !res.data) {
      return;
    }
    const arr = res.data.results || [];
    this.list = this.page === 1 ? arr : [...this.list, ...arr];
    this.total_pages = res.data.total_pages;
    if (this.page >= this.total_pages) {
      this.finished = true;
    }
  }

  upLoadData() {
    if(this.page >= this.total_pages) return;
    this.page += 1;
    this.getList();
  }

  // 获取制作同款保存数据
  getSaveData(item) {
    const { styleEN, speakerSpeed, speakerName, speakerStyle } = item;
    const data = { text: '', styleCode: styleEN, speakerName, speakerStyle, speechSpeed: speakerSpeed };
    return JSON.stringify(data);
  }
  // 跳转播放页
  doJumpPlayPage(item) {
    localStorage.setItem('videoMiguData', this.getSaveData(item));
    const { videoUrl, coverUrl } = item;
    this.$router.push({ path: '/video-play', query: { videoUrl, coverUrl, type: '2' } });
  }
  // 跳转制作页
  onCreateClick(item) {
    localStorage.setItem('textToVideoMiguData', this.getSaveData(item));
    this.$emit('reload');
  }
}
